
import { Options, Vue } from 'vue-class-component';
import loader from "@/components/loader.vue"
import dogImage from '@/components/dogImage.vue'
import inputBreed from '@/components/inputBreed.vue'

@Options({
  components: {
    loader,
    dogImage,
    inputBreed
  },
})
export default class HomeView extends Vue {
  // eslint-disable-next-line
  $store: any;

  get noBreedFound() {
    return this.$store.getters.noBreedFound
  }

  get isLoading() {
    return this.$store.getters.isLoading
  }

}
